<template>
  <div ref="streetviewContainer" class="h-full"></div>
</template>

<script>
import { defineComponent } from 'vue'
import { Loader } from '@googlemaps/js-api-loader'

export default defineComponent({
  name: 'StreetViewComponent',
  components: {},
  props: {
    latitude: {
      type: [Number, String],
      required: true
    },
    longitude: {
      type: [Number, String],
      required: true
    },
    streetview: {
      type: Object,
      required: true
    }
  },
  emits: ['update:latitude', 'update:longitude'],
  data() {
    return {
      google: null,
      map: null,
      panorama: null
    }
  },
  computed: {
    localLatitude: {
      get() {
        return this.latitude
      },
      set(value) {
        this.$emit('update:latitude', value)
      }
    },
    localLongitude: {
      get() {
        return this.longitude
      },
      set(value) {
        this.$emit('update:longitude', value)
      }
    },
    localStreetview: {
      get() {
        return this.streetview
      },
      set(value) {
        console.log('update:streetview SW component', value)
        this.$emit('update:streetview', value)
      }
    },
    center() {
      if (this.latitude !== null && this.longitude !== null) {
        return {
          lat: parseFloat(this.latitude),
          lng: parseFloat(this.longitude)
        }
      }
      return undefined
    }
  },
  mounted() {
    this.google = new Loader({
      apiKey: this.apiKey
    })
    this.initStreetview()
  },
  methods: {
    updatePovData() {
      console.log('update povData', this.panorama.getPov())
      let position = this.panorama.getPosition()
      this.localLatitude = position.lat().toFixed(8)
      this.localLongitude = position.lng().toFixed(8)
      this.localStreetview = {
        latitude: position.lat().toFixed(8),
        longitude: position.lng().toFixed(8),
        zoom: this.panorama.getZoom(),
        fov: Math.abs((this.panorama.getZoom() / 5) * 108 - 120),
        heading: this.panorama.getPov().heading,
        pitch: this.panorama.getPov().pitch
      }
    },
    initStreetview() {
      let position = {
        lat: parseFloat(this.latitude),
        lng: parseFloat(this.longitude)
      }

      this.map = new google.maps.Map(this.$refs.streetviewContainer, {
        center: position,
        zoom: 14
      })

      this.panorama = new google.maps.StreetViewPanorama(
        this.$refs.streetviewContainer,
        {
          position: position,
          zoom: this.streetview.zoom,
          pov: {
            heading: this.streetview.heading,
            pitch: this.streetview.pitch
          }
        }
      )

      this.panorama.addListener('pov_changed', () => {
        this.updatePovData()
      })
      this.panorama.addListener('position_changed', () => {
        this.updatePovData()
      })

      this.map.setStreetView(this.panorama)
    }
  }
})
</script>
